// Store local event data

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let gtagEventData = {};

// Store local table of events that have been fired
let eventsFired = {};

/**
 * Reset local scope - intended for unit tests
 */
export function resetLocalData() {
  eventsFired = {};
  gtagEventData = {};
}

/**
 * Records `eventName` has been fired
 * @param eventName
 */
export function setEventFired(eventName) {
  eventsFired[eventName] = true;
}

/**
 * Returns `true` if event has been fired
 * @param eventName
 */
export function hasEventFired(eventName) {
  return !!eventsFired[eventName];
}

/**
 * Save event data inside this module
 * @param data
 */
export function saveEventData(data) {
  // Push data to `window.dataLayer` for GTM compatibility
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);

  // Save data to local scope
  gtagEventData = {
    ...gtagEventData,
    ...data
  };
}

/**
 * Get local event data inside this module
 */
export function getEventData() {
  return gtagEventData;
}
//# sourceMappingURL=ud-server-side-gtag-state.js.map